
import { getGroups } from "@/services/api/groupsApi";
import { defineComponent } from 'vue';
// @ts-ignore
import PanelSidebarComponent from "@/components/panel/PanelSidebarComponent.vue";
// @ts-ignore
import DashboardComponent from "@/components/panel/DashboardComponent.vue";
// @ts-ignore
import StaffTableComponent from "@/components/panel/StaffTableComponent.vue";
// @ts-ignore
import TicketsTableComponent from "@/components/panel/TicketsTableComponent.vue";
// @ts-ignore
import UserLeaderboardComponent from "@/components/panel/UserLeaderboardComponent.vue";
// @ts-ignore
import TokenManagerComponent from "@/components/panel/TokenManagerComponent.vue";
// @ts-ignore
import ConfigManagerComponent from "@/components/panel/ConfigManagerComponent.vue";
// @ts-ignore
import PenaltyBlockManagerComponent from "@/components/panel/PenaltyBlockManagerComponent.vue";
// @ts-ignore
import ReportSettingsComponent from "@/components/panel/ReportSettingsComponent.vue";
// @ts-ignore
import ClassifierComponent from "@/components/panel/ClassifierComponent.vue";
// @ts-ignore
import IncidentLogComponent from "@/components/panel/IncidentLogComponent.vue";
// @ts-ignore
import IncidentDetailView from "@/components/panel/IncidentDetailView.vue";
// @ts-ignore
import StaffAssistantWidget from "@/components/panel/StaffAssistantWidget.vue";
import { User } from "shared/User";
import { apiGet } from "@/services/api/client";
import {Incident} from "shared/Incident";

export default defineComponent({
  name: "SupportPanel",
  components: {
    UserLeaderboardComponent,
    TicketsTableComponent,
    StaffTableComponent,
    DashboardComponent,
    PanelSidebarComponent,
    TokenManagerComponent,
    ConfigManagerComponent,
    PenaltyBlockManagerComponent,
    ReportSettingsComponent,
    ClassifierComponent,
    IncidentLogComponent,
    IncidentDetailView,
    StaffAssistantWidget,
  },
  data() {
    return {
      currentSection: "dashboard" as string,
      user: {} as User,
      groupsMap: {} as Record<string, any>,
      lang: 'en' as string,
      selectedIncident: null as Incident | null,
    };
  },
  watch: {
    '$route'(to) {
      this.setSectionFromHash();
      this.handleRouteChange();
    }
  },
  async created() {
    this.setSectionFromHash();
    window.addEventListener("hashchange", this.setSectionFromHash);
    await this.loadData();
    this.handleRouteChange();
  },
  beforeUnmount() {
    window.removeEventListener("hashchange", this.setSectionFromHash);
  },
  methods: {
    setSectionFromHash() {
      const hash = window.location.hash.replace("#", "");
      if (this.$route.path.startsWith('/admin/incidents')) {
        this.currentSection = 'incidents';
        return;
      }
      this.currentSection = hash || "dashboard";
    },
    async loadData() {
      try {
        // @ts-ignore
        this.user = window.userObject;
        const groupsResponse = await getGroups() as Record<string, any>;
        this.groupsMap = groupsResponse;
        const langResponse = await apiGet('/lang') as string;
        this.lang = langResponse;
      } catch (error) {
        console.error('Error loading data:', error);
      }
    },
    async handleRouteChange() {
      const onIncidentsRoute = this.$route.path.startsWith('/admin/incidents');
      if (!onIncidentsRoute && this.currentSection !== 'incidents') {
        this.selectedIncident = null;
        return;
      }
      if (onIncidentsRoute) {
        this.currentSection = 'incidents';
      }
      const id = this.$route.params.id as string | undefined;
      if (id) {
        const incident = await apiGet(`/incidents/${id}`) as Incident;
        this.selectedIncident = incident;
      } else {
        this.selectedIncident = null;
      }
    },
    closeIncidentDetail() {
      this.selectedIncident = null;
      this.$router.push('/admin/incidents');
    },
  },
});
